// extracted by mini-css-extract-plugin
export default {"recos":"J4-z","productCardOverride":"K4-z","rowHasBadge":"L4-z"};